// NPM Imports
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Button } from "../../../revvComponents";

// Components Import
import AssetsSearchBar from "../AssetsSearchBar";
import withRbac from "../../../app/withRbac";

// Internal Imports
import { GlobalUtils } from "../../../utils/index";
import { PERMISSIONS } from "../../../constants";

// Destructuring
const { readDataFromLocalStorage } = GlobalUtils;

class AssetsLeftFilter extends Component {
  state = {
    searchTerm: "",
  };

  _setSearchTerm = e => {
    this.setState({ searchTerm: e.target.value });
  };

  _clearSearch = () => {
    this.setState({ searchTerm: "" });
  };

  _clearAccountSelection = () => {
    this.props.history.push("/assets");
  };

  _filterAccounts = searchTerm => {
    const { accounts } = this.props;
    let filteredAccounts = [];
    if (accounts && accounts.length > 0) {
      if (searchTerm) {
        filteredAccounts = accounts.filter(
          account =>
            `${account.name}`.toUpperCase().indexOf(searchTerm.toUpperCase()) >=
            0,
        );
      } else {
        filteredAccounts = accounts;
      }
      return filteredAccounts;
    }
    return filteredAccounts;
  };

  _accountsListHandler = (accounts, currentSelectedAccountID) => {
    if (accounts.length > 0) {
      return accounts
        .sort((a, b) =>
          a.name.toUpperCase().localeCompare(b.name.toUpperCase()),
        )
        .map(account => (
          <li
            key={account.id}
            id={`assetsleftfilter-accounts-list-${account.id}-listitem`}
            className={`assetsleftfilter-accounts-list ${
              currentSelectedAccountID === account.id ? " active-opp-list" : ""
            }`}>
            {currentSelectedAccountID === account.id ? (
              <div
                className="assetsleftfilter-account-name"
                id={`assetsleftfilter-accounts-list-${account.id}-link-active`}>
                <span className="assetsleftfilter-accounts-crown">
                  <FontAwesomeIcon icon={["far", "briefcase"]} />
                </span>
                {account.name}
              </div>
            ) : (
              <Link
                to={`/old-assets/${account.id}`}
                className="assetsleftfilter-account-name"
                id={`assetsleftfilter-accounts-list-${account.id}-link`}>
                <span className="assetsleftfilter-accounts-crown">
                  <FontAwesomeIcon icon={["far", "briefcase"]} />
                </span>
                {account.name}
              </Link>
            )}
          </li>
        ));
    }
    return (
      <li key="no_opps">
        <div className="opps-empty-state">
          <div className="opps-empty-icon">
            <i className="opps-empty-icon-front">
              <FontAwesomeIcon icon={["far", "briefcase"]} />
            </i>
          </div>
          <span className="opps-empty-text">
            No Accounts to show. Time for a{" "}
            <span className="opps-empty-emoji" role="img" aria-label="emoji">
              ☕️
            </span>
            !
          </span>
        </div>
      </li>
    );
  };

  render() {
    const { currentSelectedAccountID, toggleAddAccPopup } = this.props;
    const { searchTerm } = this.state;
    const filteredAccounts = this._filterAccounts(searchTerm);

    // check the add new account permission ("modify_all_deals")
    const AddNewAccount = withRbac(() => (
      <div className="add-new-section">
        <Tooltip
          placement="top"
          overlay="Add New Account"
          align={{
            offset: [0, 3],
          }}>
          <Button
            className="add-oppo-btn"
            onClick={() => toggleAddAccPopup(true)}
            data-test="assetsleftfilter-add-btn">
            <i>
              <FontAwesomeIcon icon={["far", "plus"]} />
            </i>{" "}
          </Button>
        </Tooltip>
      </div>
    ));

    return (
      <div className="assetsleftfilter-wrapper">
        <div className="accfilter-acclist">
          <div className="accontsfilter-title">
            <span
              className="accontsfilter-title-text"
              data-test="accountsfilter-title-text">
              Accounts
            </span>
            {!readDataFromLocalStorage("revvsalesUser").crm_configured && (
              <AddNewAccount
                permission={PERMISSIONS.PIPELINE.MODIFY_ALL_DEALS}
              />
            )}
          </div>
          {/* ------- Account Search Bar ---------- */}
          <div className="assetsleftfilter-accounts-searchbar">
            <AssetsSearchBar
              searchTerm={searchTerm}
              setSearchTerm={this._setSearchTerm}
              clearSearch={this._clearSearch}
              clearAccountSelection={this._clearAccountSelection}
            />
          </div>

          {/* ------- Accounts List ---------- */}
          <div className="assetsleftfilter-accountslist-wrapper">
            <ul>
              {this._accountsListHandler(
                filteredAccounts,
                currentSelectedAccountID,
              )}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default AssetsLeftFilter;
